import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  DownloadFileTypeResponse,
} from '@/repositories/generated';

type FileDownloadTypeAutocompleteStoreState = {
  fileDownloadTypes: DownloadFileTypeResponse[];
};

export const useFileDownloadTypeAutocompleteStore = defineStore('fileDownloadTypeAutocomplete', {
  state: (): FileDownloadTypeAutocompleteStoreState => ({
    fileDownloadTypes: [],
  }),
  actions: {
    async getFileDownloadTypes() {
      // 一度取得したらキャッシュから取得
      if (this.fileDownloadTypes.length) {
        return this.fileDownloadTypes;
      }

      const res = await AutocompleteRepository.searchDownloadFileType();
      this.fileDownloadTypes = res;
      return res;
    },
  },
});
